import type { ObjectShape } from 'yup/lib/object';
import * as Yup from 'yup';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as ibantools from 'ibantools';

const nameWithOnlyLatinLettersRegex =
  /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi;

export const useSetupMangopayDirectDebitValidationSchema = (): ObjectShape => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      firstName: Yup.string()
        .required(t('mangopay.direct-debit.setup.required.firstName'))
        .matches(
          nameWithOnlyLatinLettersRegex,
          t('mangopay.direct-debit.setup.valid.firstName')
        ),
      lastName: Yup.string()
        .required(t('mangopay.direct-debit.setup.required.lastName'))
        .matches(
          nameWithOnlyLatinLettersRegex,
          t('mangopay.direct-debit.setup.valid.lastName')
        ),
      iban: Yup.string()
        .required(t('mangopay.direct-debit.setup.required.iban'))
        .test({
          name: 'check-iban',
          test: (rawIban, context) => {
            const iban = rawIban ?? '';
            const isValidIban =
              ibantools.isValidIBAN(iban) ||
              ibantools.isValidIBAN(ibantools.electronicFormatIBAN(iban) ?? '');
            return (
              isValidIban ||
              context.createError({
                message: t('mangopay.direct-debit.setup.valid.iban'),
              })
            );
          },
        }),
      addressLine1: Yup.string().required(
        t('mangopay.direct-debit.setup.required.address-line-1')
      ),
      addressLine2: Yup.string(),
      city: Yup.string().required(
        t('mangopay.direct-debit.setup.required.city')
      ),
      country: Yup.string().required(
        t('mangopay.direct-debit.setup.required.country')
      ),
      postalCode: Yup.string()
        .required(t('mangopay.direct-debit.setup.required.postal-code'))
        .matches(/^\d+$/, t('mangopay.direct-debit.setup.valid.postal-code')),
    }),
    [t]
  );
};
